/**
 * Pure readers for the lock fields of GET /api/agency/portfolio.
 * The route answers `{ success, data: { clients }, lockedFeatures, lockedFeatureUpsell? }`: the lock fields sit
 * at the TOP LEVEL of the body, next to `data`, not inside it.
 */

export interface PortfolioLockFields {
  /** Feature keys the AGENCY package lacks (non-empty only when the backend enforces) */
  lockedFeatures: string[];
  /** Cheapest plan slug per locked key, when the backend knows it */
  lockedFeatureUpsell: Record<string, string>;
}

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

export const extractPortfolioLockFields = (body: unknown): PortfolioLockFields => {
  const record = isRecord(body) ? body : {};
  const lockedFeatures = Array.isArray(record.lockedFeatures)
    ? record.lockedFeatures.filter((k): k is string => typeof k === 'string')
    : [];
  const lockedFeatureUpsell: Record<string, string> = {};
  if (isRecord(record.lockedFeatureUpsell)) {
    for (const [key, slug] of Object.entries(record.lockedFeatureUpsell)) {
      if (typeof slug === 'string') lockedFeatureUpsell[key] = slug;
    }
  }
  return { lockedFeatures, lockedFeatureUpsell };
};
